// validation.js
export const ValidateTestCreateForm = (formData, questions) => {
    const errors = [];
    const { testName, category, customCategory, minutes, outOfMarks, markDistribution, passingPercentage } = formData;
    
    // Basic required field validations
    if (!testName.trim()) {
        errors.push({ field: 'testName', message: 'Test name is required.' });
    }

    if (!category) {
        errors.push({ field: 'category', message: 'Please select a category.' });
    }

    if (category === 'other' && !customCategory.trim()) {
        errors.push({ field: 'customCategory', message: 'Custom category is required.' });
    }

    if (!minutes || isNaN(minutes) || parseInt(minutes) <= 0) {
        errors.push({ field: 'minutes', message: 'Please enter valid duration.' });
    }
    // Validate markDistribution and related fields
    if (markDistribution === 'total') {
        if (!outOfMarks || isNaN(outOfMarks) || outOfMarks <= 0) {
            errors.push({ field: 'outOfMarks', message: 'Please enter valid total marks' });
        }

    } else if (markDistribution === 'question') {
        // Validate that all questions have marks
        questions.forEach((q, index) => {
            if (!q.marks || isNaN(q.marks) || q.marks <= 0) {
                errors.push({
                    field: `question${index}Marks`,
                    message: `Question ${index + 1} has invalid marks`
                });
            }
        });
    } else {
        errors.push({
            field: 'markDistribution',
            message: 'Invalid mark distribution type'
        });
    }
    if (!passingPercentage || isNaN(passingPercentage) || passingPercentage < 0 || passingPercentage > 100) {   
        errors.push({ field: 'passingPercentage', message: 'Please enter a valid passing percentage between 0 and 100' });
    }

    // Question validations
    questions.forEach((question, qIndex) => {
        if (!question.question.trim()) {
            errors.push({ field: `question${qIndex}`, message: `Question ${qIndex + 1} text is required.` });
        }

        // Check each option is filled
        question.options.forEach((option, optIndex) => {
        const optionStr = typeof option === 'string' ? option : String(option);
            if (!optionStr.trim()) {
                errors.push({
                    field: `option${qIndex}-${optIndex}`,
                    message: `Question ${qIndex + 1}: Option ${optIndex + 1} cannot be empty.`
                });
            }
        });

        // Correct answer validation based on question type
        if (question.type === 'single') {
            if (question.correctOption === undefined || question.correctOption === '') {
                errors.push({
                    field: `correctOption${qIndex}`,
                    message: `Question ${qIndex + 1}: Please select the correct answer.`
                });
            }
        } else {
            // For multiple-choice - require at least 2 correct answers
            if (!question.correctOptions || question.correctOptions.length < 2) {
                errors.push({
                    field: `correctOptions${qIndex}`,
                    message: `Question ${qIndex + 1}: Please select at least 2 correct answers.`
                });
            }
        }
    });

    return errors;
};
